module.exports = __webpack_public_path__ + "img/89.421c5280.jpg";